/**
 * @generated SignedSource<<6cbfc6fb26ab47c938e2e107134857cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppointmentTypeStep_query$data = {
  readonly supportedLanguages: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    }>;
  } | null;
  readonly " $fragmentType": "AppointmentTypeStep_query";
};
export type AppointmentTypeStep_query$key = {
  readonly " $data"?: AppointmentTypeStep_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppointmentTypeStep_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppointmentTypeStep_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SupportedLanguagesConnection",
      "kind": "LinkedField",
      "name": "supportedLanguages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SupportedLanguage",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "92895d1e14dcb89e9d17333eefafa5c5";

export default node;
